import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery";
import { SLS_URL } from "../../Config/slsConfig";
import {
  DTOInputBookmarkUpdate,
  DTOOutputBookmarkUpdate,
  RequestBookmarkFavorite,
  RequestBookmarkRead,
  ResponseBookmarkReadWithTextId,
} from "../../Services/Serverless/Lookup/Bookmark/bookmark.interface";

export const BookmarkApi = createApi({
  reducerPath: "bookmarkApi",
  baseQuery: axiosBaseQuery({ baseUrl: SLS_URL }),
  tagTypes: ["Bookmark"],
  endpoints: (builder) => ({
    readBookmarks: builder.query<
      ResponseBookmarkReadWithTextId,
      { token: string; params: RequestBookmarkRead }
    >({
      query: ({ token, params }) => ({
        url: "/bookmarks",
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        data: params,
      }),
      providesTags: ["Bookmark"],
    }),
    updateBookmarks: builder.mutation<
      DTOOutputBookmarkUpdate,
      { data: DTOInputBookmarkUpdate; token: string }
    >({
      query: (input) => ({
        url: "/bookmarks/update",
        method: "POST",
        headers: { Authorization: `Bearer ${input.token}` },
        data: input.data,
      }),
      invalidatesTags: ["Bookmark"],
    }),
    favoriteBookmark: builder.mutation<
      ResponseBookmarkReadWithTextId,
      { data: RequestBookmarkFavorite; token: string }
    >({
      query: ({ token, data }) => ({
        url: "/bookmarks/favorite",
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        data,
      }),
      invalidatesTags: ["Bookmark"],
    }),
  }),
});

export const {
  useReadBookmarksQuery,
  useUpdateBookmarksMutation,
  useFavoriteBookmarkMutation,
} = BookmarkApi;
